import { render } from "./Balancer.vue?vue&type=template&id=bdd6e1c0&scoped=true"
import script from "./Balancer.vue?vue&type=script&lang=js"
export * from "./Balancer.vue?vue&type=script&lang=js"

import "./Balancer.vue?vue&type=style&index=0&id=bdd6e1c0&scoped=true&lang=scss"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd6e1c0"]])

export default __exports__